import { IllustrationProps } from 'fe-design-base/assets/types';
import Box from 'fe-design-base/atoms/Box';

import chalk_play from './imageFiles/chalk_play.png';

const ChalkPlay = (props: IllustrationProps) => (
  <Box
    w={72}
    {...props}
    minw={72}
    className={`FDBIllustration${
      props?.className ? ` ${props.className}` : ''
    }`}
  >
    <img
      src={chalk_play}
      style={{ width: '100%' }}
      alt="Chalk Play Illustration"
    />
  </Box>
);
export default ChalkPlay;
